import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface AdminRouteProps {
    children: React.ReactNode
}

/**
 * Route guard that only allows admin users.
 * Redirects to appropriate page based on role:
 * - No user: redirects to home (login)
 * - Expert: redirects to /especialista
 * - Participant: redirects to /participante
 */
export function AdminRoute({ children }: AdminRouteProps) {
    const { user, userRole, loading } = useAuth()

    // Show nothing while loading (prevents flash)
    if (loading) {
        return (
            <div className="min-h-screen d-flex align-items-center justify-content-center">
                <div className="spinner"></div>
            </div>
        )
    }

    // Not logged in - redirect to home
    if (!user) {
        return <Navigate to="/" replace />
    }

    // Not admin - redirect to appropriate page
    if (userRole !== 'admin') {
        const redirectPath = userRole === 'expert' ? '/especialista' : '/participante'
        console.log(`[AdminRoute] Non-admin user (${userRole}), redirecting to ${redirectPath}`)
        return <Navigate to={redirectPath} replace />
    }

    // Admin - allow access
    return <>{children}</>
}
